// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::close:::Close]]',
  error: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::error:::Error]]',
  warn: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::warn:::Warning]]',
  info: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::info:::Info]]',
  confirmation: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::confirmation:::Confirmation]]',
  progressIndeterminate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::progressIndeterminate:::In Progress]]',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_separatorLabel:::Between ' +
    p['FROM_SECTION'] +
    ' and ' +
    p['TO_SECTION'] +
    '.]]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_disabledLabel:::' +
    p['SECTION'] +
    '. No matching section found.]]',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_keyboardInstructionText:::Press enter to select value.]]',
  indexer_touchInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_touchInstructionText:::Double tap and hold to enter gesture mode, then drag up or down to adjust value.]]',
  inputPassword_show: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_show:::Show Password]]',
  inputPassword_hide: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hide:::Hide Password]]',
  inputPassword_hidden: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hidden:::Password Hidden]]',
  formControl_clear: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_clear:::Clear]]',
  formControl_loading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_loading:::Loading]]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthExceeded:::Maximum length ' +
    p['MAX_LENGTH'] +
    ' exceeded.]]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthRemaining:::' +
    p['CHARACTER_COUNT'] +
    ' characters left.]]',
  formControl_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_requiredMessageDetail:::Enter a value.]]',
  select_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_requiredMessageDetail:::Select a value.]]',
  select_noMatchesFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_noMatchesFound:::No matches found.]]',
  select_oneMatchFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_oneMatchFound:::One match found]]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' matches found]]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeOrMoreMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' or more matches found]]',
  selectMultiple_selectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_selectedValues:::Selected values]]',
  selectMultiple_showSelectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_showSelectedValues:::Show selected values only.]]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_valuesSelected:::' +
    p['VALUE_COUNT'] +
    ' values selected.]]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_removeSelectedTagInstructionText:::Press Backspace or Delete to remove the selected value.]]',
  selectMultiple_apply: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_apply:::Apply]]',
  selectMultiple_back: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_back:::Back]]',
  selector_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_selected:::Checkbox checked]]',
  selector_unselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_unselected:::Checkbox not checked]]',
  userAssistance_learnMore: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_learnMore:::Learn more]]',
  userAssistance_required: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_required:::Required]]',
  filePicker_singleFileUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleFileUploadError:::Upload one file at a time]]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleTypeUploadError:::You can't upload files of type " +
    p['fileType'] +
    ']]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_multipleFileTypeUploadError:::You can't upload files of type: " +
    p['fileTypes'] +
    ']]',
  filePicker_unknownFileTypeUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_unknownFileTypeUploadError:::unknown]]',
  filePicker_dropzonePrimaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzonePrimaryText:::Drag and Drop]]',
  filePicker_dropzoneSecondaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryText:::Select a file or drop one here]]',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryTextMultiple:::Select or drop files here]]',
  filePicker_addFiles: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_addFiles:::Add Files]]',
  plural_separator: () => ', ',
  inputNumber_increase: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_increase:::Increase]]',
  inputNumber_decrease: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_decrease:::Decrease]]',
  inputNumber_converterParseError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_converterParseError:::Enter a number.]]',
  noData_message: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::noData_message:::No items to display]]',
  message_navigationFromMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationFromMessagesRegion:::Entering messages region. Press F6 to navigate back to prior focused element.]]',
  message_navigationToMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationToMessagesRegion:::Messages region has new messages. Press F6 to navigate to the most recent message region.]]',
  messageToast_allMessagesClosed: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::messageToast_allMessagesClosed:::All toast messages are closed.]]',
  expandableList_groupCollapse: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupCollapse:::Collapsed]]',
  expandableList_groupExpand: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupExpand:::Expanded]]',
  expandableList_expandCollapseInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_expandCollapseInstructionText:::Use arrow keys to expand and collapse]]',
  list_suggestion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::list_suggestion:::Suggestion]]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_status:::Step ' +
    p['currentStep'] +
    ' out of ' +
    p['numberOfSteps'] +
    ']]',
  train_current: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_current:::Current]]',
  train_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_visited:::Visited]]',
  train_not_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_not_visited:::Not visited]]',
  train_message_type: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_message_type:::Message Type]]',
  viz_drillable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::viz_drillable:::Drillable]]',
  dataVisualization_stateSelected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_stateSelected:::Selected]]',
  dataVisualization_stateUnselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_stateUnselected:::Unselected]]',
  dataVisualization_noData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_noData:::No data to display]]'
};
export default bundle;
